(function ($, window) {
  let $pushCheckbox;
  let $registrationUrlObj;
  let $serviceWorkerObj;
  let $appKeyObj;
  let $skeyObj;
  let serviceWorkerUrl;
  let registrationUrl;
  let appKey;
  let skey;

  const getSWRegistration = function () {
    return navigator.serviceWorker.register(serviceWorkerUrl);
  };

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    /* eslint-disable-next-line */
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  function registerServiceWorker() {
    return navigator.serviceWorker
      .register(serviceWorkerUrl)
      .then((registration) => {
        registration.update();
        return registration;
      })
      .catch((err) => {
        console.error('Unable to register service worker.', err);
      });
  }

  function askPermission() {
    return new Promise(((resolve, reject) => {
      const permissionResult = Notification.requestPermission((result) => {
        resolve(result);
      });

      if (permissionResult) {
        permissionResult.then(resolve, reject);
      }
    })).then((permissionResult) => {
      if (permissionResult !== 'granted') {
        throw new Error("We weren't granted permission.");
      }
    });
  }

  /**
   * Using `Notification.permission` directly can be slow (locks on the main
   * thread). Using the permission API with a fallback to
   * `Notification.permission` is preferable.
   * @return {Promise<String>} Returns a promise that resolves to a notification
   * permission state string.
   */
  function getNotificationPermissionState() {
    if (navigator.permissions) {
      return navigator.permissions
        .query({ name: 'notifications' })
        .then((result) => result.state);
    }

    return new Promise(((resolve) => {
      resolve(Notification.permission);
    }));
  }

  function sendSubscriptionToBackEnd(subscription) {
    const sub = JSON.parse(JSON.stringify(subscription));
    sub.skey = skey;

    return $.post(registrationUrl, JSON.stringify(sub))
      .then((response) => {
        if (!response.data.success) {
          console.error(response);
          throw new Error('Bad status code from server.');
        }

        return response;
      })
      .then((responseData) => {
        if (!(responseData.data && responseData.data.success)) {
          throw new Error('Bad response from server.');
        }
      });
  }

  function subscribeUserToPush() {
    return getSWRegistration()
      .then((registration) => {
        const subscribeOptions = {
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(appKey),
        };

        return registration.pushManager.subscribe(subscribeOptions);
      })
      .then((pushSubscription) => pushSubscription);
  }

  function unsubscribeUserFromPush() {
    return registerServiceWorker()
      .then((registration) => registration.pushManager.getSubscription())
      .then((subscription) => {
        if (!subscription) {
          return false;
        }

        return subscription.unsubscribe();
      })
      .then(() => {
        console.info('User successfully unsubscribed!');
      })
      .catch((err) => {
        console.error('Failed to unsubscribe the user.', err);
      });
  }

  function subscribe(registration, currentPermissionState) {
    // Just been checked meaning we need to subscribe the user
    // Do we need to wait for permission?
    let promiseChain = Promise.resolve();
    if (currentPermissionState !== 'granted') {
      promiseChain = askPermission();
    }

    promiseChain
      .then(subscribeUserToPush)
      .then((subscription) => {
        if (subscription) {
          return sendSubscriptionToBackEnd(subscription).then(() => subscription);
        }
        return subscription;
      })
      .then(() => {
        console.info('User successfully subscribed!');
      })
      .catch((err) => {
        console.error('Failed to subscribe the user.', err);
      });
  }

  function setUpPush() {
    return Promise.all([
      registerServiceWorker(),
      getNotificationPermissionState(),
    ])
      .then((results) => {
        const registration = results[0];
        const currentPermissionState = results[1];

        if (currentPermissionState === 'denied') {
          console.warn(
            'The notification permission has been blocked. Nothing we can do.',
          );
          $pushCheckbox.prop('disabled', true);
          $pushCheckbox.parent().css('display', 'none');
          return;
        }

        if (currentPermissionState !== 'granted') {
          // If permission isn't granted than we can't be subscribed for Push.
          $pushCheckbox.prop('disabled', true);
          $pushCheckbox.parent().css('display', 'none');
          return;
        }

        if (window.pushNotificationsEvent === 'subscribe') {
          subscribe(registration, currentPermissionState);
        } else if (window.pushNotificationsEvent === 'unsubscribe') {
          unsubscribeUserFromPush();
        }
      })
      .catch((err) => {
        console.error(`Unable to register the service worker: ${err}`);
      });
  }

  $(() => {
    if (!('serviceWorker' in navigator)) {
      // Service Worker isn't supported on this browser, disable or hide UI.
      return;
    }

    if (!('PushManager' in window)) {
      // Push isn't supported on this browser, disable or hide UI.
      return;
    }

    askPermission();

    $registrationUrlObj = $('#js-registration-url');
    $pushCheckbox = $('#js-input-chrome-notifications');
    $serviceWorkerObj = $('#js-app-worker');
    $appKeyObj = $('#js-app-key');
    $skeyObj = $('#js-app-skey');

    serviceWorkerUrl = $serviceWorkerObj.data('app-service-worker');
    registrationUrl = $registrationUrlObj.data('registration-url');
    appKey = $appKeyObj.data('app-key');
    skey = $skeyObj.data('app-skey');

    setUpPush();
  });
}(window.jQuery, window, document));
